import { getQueryDataFromKey } from '@pba/react-query';
import { useCallback } from 'react';
import type { ChatroomDataObject } from '#models/services';
import { useQueryClient } from '#react-query';
import { type ChatroomsQueryData, getChatroomDetailQueryKey } from '../use-get-chatroom';
import { type ChatroomsInfiniteQueryData, getChatroomsInfiniteQueryKey } from '../use-get-chatrooms';

export const useGetChatroomFromCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (chatroomId: string): ChatroomDataObject | undefined => {
      const detailChatroom = getQueryDataFromKey<ChatroomsQueryData>(
        queryClient,
        getChatroomDetailQueryKey({ id: chatroomId }),
      );

      if (detailChatroom) {
        return detailChatroom;
      }

      const infiniteChatrooms = getQueryDataFromKey<ChatroomsInfiniteQueryData>(
        queryClient,
        getChatroomsInfiniteQueryKey({}),
      );

      return infiniteChatrooms?.pages.flat().find((item) => item?._id === chatroomId) ?? undefined;
    },
    [queryClient],
  );
};
